module.exports = __webpack_public_path__ + "static/media/156-turks-and-caicos.e349d7a4.svg";